import 'video.js';
import videojs from 'video.js/dist/video.es';
import { Logger } from '../../02_utils/logger';
import Player from 'video.js/dist/types/player';

export class Video {
  private videoElements: NodeListOf<HTMLVideoElement> = document.querySelectorAll('.js-videojs');

  constructor(private $log: Logger) {
    this.$log.debug(this.videoElements);
    this.videoElements?.forEach(element => {
      this.handleVideos(element);
    });
  }

  private handleVideos(video: HTMLVideoElement) {
    let player: Player = null;
    if (video.classList.contains('js-autoplay')) {
      player = videojs(video, {controls: false});
    } else {
      player = videojs(video);
    }

    // Event-Listener für den Vollbildmodus mit Video.js-spezifischem Event
    player?.on('fullscreenchange', () => {
      const sdSource = video.querySelector('source[data-source="sourcesd"]') as HTMLSourceElement;
      const sourceHd = video.querySelector('source[data-source="sourcehd"]') as HTMLSourceElement;
      const currentTime = player.currentTime();

      this.$log.debug(sdSource, sourceHd, currentTime);

      if (sdSource && sourceHd) {
        if (player.isFullscreen()) {
          player.src({ type: 'video/mp4', src: sourceHd.src });
          player.currentTime(currentTime);
          player.play();

        } else {
          player.src({ type: 'video/mp4', src: sdSource.src });
          player.currentTime(currentTime);
          player.play();
        }
      }
    });
  }
}
